import { api } from '@/redux/api/api';
import { QuerySuccessHandler } from '@/redux/types/query-success-handler';
import { addItemRecipe } from '@/redux/utils/add-item-recipe';
import { AddResidentToUnitQueryArg } from '../types/query-arg';

export const dispatchSuccessPatchAddResidentToUnit: QuerySuccessHandler<
  AddResidentToUnitQueryArg
> = ({ resident, unitId }, { dispatch }) => {
  dispatch(
    api.util.updateQueryData(
      'getResidentsInUnit',
      { unitId },
      addItemRecipe(resident),
    ),
  );
};
